import {hashSum} from 'helpers';
import {PointerEvent, MouseEvent} from 'react';
import {AnyObject} from 'types';

export function modal<T>(Component: Modal<T>, props: T & {dismissible?: boolean} = {}) {
  return (event?: PointerEvent | MouseEvent) => {
    // in case it's inside <Link> or <NavLink>
    event?.stopPropagation();
    event?.preventDefault();
    return new Promise((resolve, reject) => {
      window.dispatchEvent(new CustomEvent('popuptoggle', {
        detail: {
          Component,
          id: 'm' + hashSum(Component),
          align,
          props,
          modal: true,
          resolve,
          reject,
        }
      }));
    });
  };
}

function align(popup: AnyObject) {
  return {
    ...popup,
    className: {
      modal: true,
      [popup.props.className || 'modal']: true
    }
  };
}

interface Controls {
  back: () => void;
  bounce: () => void;
  close: () => void;
  detach: () => void;
  id: string;
  redirect: <T>(Component: React.FC<T>, props: T, push?: boolean) => () => void;
  setClassName: (value: string) => void;
}

export type Modal<T = {}> = React.FC<T & {
  popup: Controls;
  modal?: Controls;
}>
